import { render } from "./IconMinus.vue?vue&type=template&id=d3954b44"
import script from "./IconMinus.vue?vue&type=script&lang=js"
export * from "./IconMinus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__